const $header = $('.masthead__header'),
    $wrapper = $('.sticky-nav-bar'),
    $navBar = $('.sticky-nav-bar__inner'),
    classNavBarSticky = 'sticky-nav-bar--sticky';

let scrolledDistance,
    navBarStickyTreshold;

if ($navBar.length > 0) {

    $(window).on('scroll', function () {
        scrolledDistance = $(document).scrollTop();
        navBarStickyTreshold = 0;

        navBarStickyTreshold = navBarStickyTreshold + $wrapper.offset().top;
        navBarStickyTreshold = navBarStickyTreshold - $header.outerHeight() -1;

        if (scrolledDistance > navBarStickyTreshold) {
            $wrapper.css('height', $navBar.outerHeight());
            $wrapper.addClass(classNavBarSticky);
        } else {
            $wrapper.removeClass(classNavBarSticky);
            $wrapper.css('height', 'auto');
        }
    });
}